export const restorePreviousFocus = (
  previouslyFocusedElementRef: HTMLElement | null
) => {
  const previousEl = previouslyFocusedElementRef

  if (previousEl && document.body.contains(previousEl)) {
    previousEl.focus()
  } else {
    // Try to focus nearest previous focusable element
    const allFocusable = getFocusableElements(document.body)
    const index = allFocusable.findIndex((el) => el === previousEl)
    // Fallback to previous element if possible, else first one
    if (index > 0) {
      allFocusable[index - 1].focus()
    } else if (allFocusable.length > 0) {
      allFocusable[0].focus()
    }
  }
}
export const getFocusableElements = (
  container: HTMLElement | Document | null
): HTMLElement[] => {
  if (!container) return []
  return Array.from(
    container.querySelectorAll<HTMLElement>(
      'button, [href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )
  ).filter((el) => !el.hasAttribute('disabled') && el.tabIndex >= 0)
}
